import { computed } from 'vue'
import type { ComputedRef, Ref } from 'vue'

import { resolveLocaleMessages } from './catalog.ts'
import type { LocaleCatalog, LocaleMessageTree } from './catalog.ts'
import type { AppLocale } from './locales.ts'

export function useLocaleMessages<T extends LocaleMessageTree>(
  catalog: LocaleCatalog<T>,
  locale: Readonly<Ref<AppLocale>>,
): ComputedRef<LocaleCatalog<T>[AppLocale]> {
  return computed(() => resolveLocaleMessages(catalog, locale.value))
}
